// extracted by mini-css-extract-plugin
export default {"rich-text-editor":"_1lySn2AI-71zMRZNt2S-BD"};